import React from 'react';
import { Spinner } from 'react-bootstrap';

interface SaveButtonProps {
  /** Something differs from the saved state. */
  dirty: boolean;
  saving: boolean;
  /** Extra reason to hold the button (another request in flight, etc.). */
  disabled?: boolean;
  label: string;
  /** Small pill after the label, e.g. "2 unsaved". */
  badge?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
}

// Card-header save button: outlined "Nothing to save" until there is a change, then filled
// with the label (and optional badge); a spinner while the request runs.
const SaveButton: React.FC<SaveButtonProps> = ({
  dirty,
  saving,
  disabled = false,
  label,
  badge,
  type = 'button',
  onClick,
}) => (
  <button
    // eslint-disable-next-line react/button-has-type
    type={type}
    className={`btn-app btn-app--sm ${
      dirty ? 'btn-app--primary' : 'btn-app--outline'
    }`}
    onClick={onClick}
    disabled={!dirty || saving || disabled}
  >
    {saving && <Spinner size="sm" />}
    {!saving && !dirty && 'Nothing to save'}
    {!saving && dirty && (
      <>
        {label}
        {badge ? <span className="btn-app-badge">{badge}</span> : null}
      </>
    )}
  </button>
);

export default SaveButton;
